import { gql } from "graphql-request"

const tezos = {
    name: 'tezos',
    title: 'Tezos',
    currency: 'XTZ',
    check: true,
    regexp: '([\\W]|^)((tz1|KT1|tz3|tz2)[\\w]{33})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        tezos(network: tezos) {
            address(address: {is: $address}) {
                balance {
                    balance: available
                    balance_usd: available(in: USD)
                }
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }
    `,
    checkAddress: 'tz3bTdwZinP8U1JmSweNzVKhmwafqWmFWRfk',
}
export { tezos }
